import { render } from "./voiceswiper.vue?vue&type=template&id=134e0c0f&scoped=true"
import script from "./voiceswiper.vue?vue&type=script&lang=js"
export * from "./voiceswiper.vue?vue&type=script&lang=js"

import "./voiceswiper.vue?vue&type=style&index=0&id=134e0c0f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134e0c0f"]])

export default __exports__